import React from "react"
import styled from "styled-components"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import {
  setColor,
  setRem,
  media,
  setLetterSpacing,
  setTransition,
} from "../../style"
import socialIcons from "../../constants/social-icons"
import { FaSms } from "react-icons/fa"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"
import {FormattedMessage} from "gatsby-plugin-intl"
import Language from "./Language"

const getImage = graphql`
  query {
    fridaLogo: file(relativePath: { eq: "frida-travel-logo.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`

const Header = () => {
  const data = useStaticQuery(getImage)
  
  return (
    <Container>

    <div className="header">
      <AniLink swipe direction="left" to="/">
        <Image fluid={data.fridaLogo.childImageSharp.fluid} className="header-logo"/>
      </AniLink>
      

      <div className="cell center">
        <ClickToCallDiv>
          <FormattedMessage 
            id="header.clicktocall"
          />
        </ClickToCallDiv>
        <PhoneNumber>
          <a href="tel: 1 888 987 2977">1 888 987 2977</a>
        </PhoneNumber>

        <ClickToSms> <FormattedMessage id="header.or"/> <br />
        <a href="sms:+526699415632"><FaSms/> <FormattedMessage 
          id="header.messageUs" /></a>
        </ClickToSms>
        <MailToDiv>
          <a href="mailto:info@fridatravel.com">info@fridatravel.com</a>
        </MailToDiv>
      </div>

      <FollowUs className="nav-social-links">
        <p><FormattedMessage id="header.followUs" /></p>
        {socialIcons.map((item, index) => {
          return (
            <a
              key={index}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.icon}
            </a>
          )
        })}
        <Language />
      </FollowUs>
      </div>  
    </Container>
  )
}

export default Header

const Container = styled.div`
background-color: ${setColor.mainWhite};
width: 100%;
.header-logo {
  width: ${setRem(121)};
  height: ${setRem(70)};
  ${media.tablet`
        width: ${setRem(173)};
        height: ${setRem(100)};
    `}
}

.header {
  max-width: 1170px;
  margin: auto;
  line-height: 1.2;
  padding: ${setRem(10)};
  height: ${setRem(94)};
  background-color: ${setColor.mainWhite};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  ${media.tablet`
     height: ${setRem(118)};
  `}
}
  .cell {
    border-left: 1px solid #e0e1e0;
    padding-left: 3vw;
    
    ${media.tablet`
    padding-left: 5vw;
    border-right: 1px solid #e0e1e0;
    padding-right: 5vw;
    `}
  }

  .nav-social-links a {
    color: ${setColor.lightGrey};
    margin: 0 0.5rem;
    font-size: 1.2rem;
    ${setTransition};
    ${media.phone`
            font-size: 2rem;
        `}
  }
  .nav-social-links a:hover {
    color: ${setColor.mainBlack};
    transform: translateY(-5px);
  }
`
const ClickToCallDiv = styled.div`
  color: ${setColor.mainGrey};
  font-weight: bolder;
  font-size: ${setRem(10)};
  text-transform: uppercase;
  text-align: center;
  ${setLetterSpacing(3)};
  ${media.tablet`
            font-size: ${setRem(20)};
        `}
`

const ClickToSms = styled.div`
  margin-top: ${setRem(5)};
  color: ${setColor.mainGrey};
  font-weight: bolder;
  font-size: ${setRem(10)};
  text-transform: uppercase;
  text-align: center;
  ${setLetterSpacing(3)};
  ${media.phone`
       display: none;
  `}
  
  a {
    ${setLetterSpacing(1)};
    color: #33b333;
    text-decoration: none;
    font-weight: bold;
    font-size: ${setRem(12)};
  }
`

export const PhoneNumber = styled.div`
  font-weight: bold;
  font-size: ${setRem(20)};
  a {
    color: ${setColor.secondaryColor};
    text-decoration: none;
  }
  ${media.phone`
                font-size: ${setRem(38)};
        `}
`

export const MailToDiv = styled.div`
  display: none;

  ${media.tablet`
        font-size: ${setRem(21)};
        display: unset;
    `}
  a {
    font-size: ${setRem(17)};
    color: ${setColor.mainGrey};
  }
`

export const FollowUs = styled.div`
  font-size: ${setRem(20)};
  font-weight: bold;
  color: ${setColor.primaryColor};
  text-transform: uppercase;
  display: none;
  p {
    margin-bottom: ${setRem(5)};
    margin-top: ${setRem(5)};
  }
  ${media.tablet`
        font-size: ${setRem(23)};
        display: unset;
    `}
`
